<template ref="mousePosition">
  <article class="home layout" ref="top">
    <TheNavBar @scroll-event="scrollToTop" style="position: sticky; top: 0" />
    <TheHero>
      <template #title>
        <h1 v-html="title" class="home__title" />
      </template>

      <template #content>
        <BaseRotator />
      </template>
    </TheHero>

    <TheCursor
      :style="{ left: x - 30 + 'px', top: y - 30 + 'px' }"
      @mousemove="onMousemove"
    />

    <section class="layout__content">
      <h2>Ben je van plan je woning te verkopen?</h2>
      <p>
        Ik kom graag bij je langs om je woning te bekijken en kennis met je te
        maken. Je ontvangt advies op maat. Gaan we samenwerken? Dan begeleid ik
        je tijdens het gehele verkoopproces, tot aan de overdracht van je
        woning.
      </p>
    </section>

    <section class="layout__content">
      <h2>Wel of geen aankoopmakelaar in de arm nemen?</h2>
      <p>
        Een (nieuw) huis kopen is leuk en spannend. Het is een grote investering
        en er komt veel op je af. Veel informatie kun je online vinden, maar je
        kunt ook een professional inschakelen.
      </p>
    </section>

    <section class="layout__content layout__end">
      <h2>Wat doet een aankoopmakelaar eigenlijk?</h2>

      <p>
        Een aankoopmakelaar helpt je bij het vinden en kopen van een huis, is
        goed op de hoogte van de lokale woningmarkt en weet wat er te koop is.
        Zo zit je als koper dicht bij het vuur. Handig, vooral in een gewilde
        regio zoals Amsterdam.
      </p>

      <p>
        Je wordt als eerste op de hoogte gebracht van nieuw aanbod, gewezen op
        belangrijke zaken en ondersteund bij het doornemen van documenten. Zo
        ben je altijd goed geïnformeerd.
      </p>

      <p>
        Daarnaast doet de aankoopmakelaar onderzoek en informeert je over de
        waarde van een woning. Op basis daarvan kun je beslissen of je een bod
        wilt uitbrengen, waarbij de makelaar je uiteraard begeleidt.
      </p>

      <p>
        Ik help je graag bij alle stappen die komen kijken bij het kopen van een
        nieuwe woning, van het eerste gesprek tot aan de feestelijke
        sleuteloverdracht bij de notaris. Jij hoeft alleen nog te voelen of het
        huis bij je past.
      </p>

      <p>
        Ben je van plan je huis te verkopen? Of ben je (eerst) op zoek naar een
        nieuwe woning? Neem dan gerust contact met me op voor een vrijblijvende
        afspraak om je wensen te bespreken.
      </p>
    </section>

    <TextImageBlock
      image="/ip-makelaardij-iwana-puhalovic.jpg"
      alt="Iwana Puhalovic Makelaar in Amsterdam"
    >
      <template #title>
        <h2>Over Iwana Puhalovic</h2>
      </template>

      <template #description>
        <section class="layout__end">
          <p>
            Sinds 2005 ben ik werkzaam in de makelaardij en nog altijd doe ik
            dat met veel plezier Ik heb het voorrecht om te werken in en rondom
            het bruisende Amsterdam, wat mij betreft de mooiste stad die er is.
            De karakteristieke straten, de diverse bouwstijlen en de enorme
            verscheidenheid aan mensen blijven mij elke dag inspireren.
          </p>
        </section>
      </template>

      <template #cta>
        <BaseButton>
          <a href="mailto:welkom@ipmakelaardij.nl" target="_blank"
            ><i class="fa-solid fa-envelope"></i> Mail voor een afspraak</a
          >
        </BaseButton>
      </template>
    </TextImageBlock>

    <section class="layout__content layout__end">
      <h2>Wil jij ook persoonlijk advies?</h2>

      <p>
        Mijn werk draait niet alleen om het aankopen of verkopen van een huis.
        Het is mensenwerk, gebaseerd op vertrouwen. Het gaat om een spannende en
        emotionele gebeurtenis die iemand meestal maar een paar keer in zijn of
        haar leven meemaakt.
      </p>

      <p>
        Ik werk met mijn hart, neem de tijd voor mijn klanten en ben persoonlijk
        betrokken. Dat maakt mijn werk extra waardevol. Ik mag elke dag werken
        in de mooiste stad én deel uitmaken van een bijzondere gebeurtenis in
        iemands leven.
      </p>

      <p>Graag ga ik ook met jou een mooie samenwerking aan!</p>
      <p>Hopelijk tot gauw.</p>
    </section>
    <TheFooter />
  </article>
</template>

<script setup>
import TheHero from "@/components/TheHero.vue";
import BaseButton from "@/components/BaseButton.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheNavBar from "@/components/TheNavBar.vue";
import TextImageBlock from "@/components/TextImageBlock.vue";
import BaseRotator from "@/components/BaseRotator.vue";
import TheCursor from "@/components/TheCursor.vue";

import { ref, onMounted, onUnmounted } from "vue";

const title = `Persoonlijk advies<br>bij al jouw woonvragen`;

//Mouse tracker
const x = ref(0);
const y = ref(0);

function update(event) {
  x.value = event.pageX;
  y.value = event.pageY;
}

onMounted(() => window.addEventListener("mousemove", update));
onUnmounted(() => window.removeEventListener("mousemove", update));

//Scroll to top
const top = ref(null);

function scrollToTop() {
  top.value.scrollIntoView({ behavior: "smooth" });
}
</script>
